import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from "axios";
import { LoginModel } from 'models/LoginModel';
import { getAccessToken } from 'services/user.service';

import { dangerAlert } from 'reducers/alert.slice';

const authenticationApi = axios.create({
    baseURL: process.env.REACT_APP_BCDAPIURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

export const login = createAsyncThunk('authenticate/login',
    async function (loginModel: LoginModel, { dispatch }) {
    try {
        const loginJson = JSON.stringify(loginModel);

        const response = await authenticationApi.post(
            "authentication/login",
            loginJson);
        if (response.data.token) {
            localStorage.setItem("user", JSON.stringify(response.data));
             //if (history.navigate != null)
             //    history.navigate('/alliance');
            return response.data;
        }
        throw new Error(response.data);
    } catch (err) {
        localStorage.removeItem("user");
        const error = err as AxiosError;
        dispatch(dangerAlert({ message: JSON.stringify(error.response?.data || "An error occurred processing the request"), showAfterRedirect: false }));
    }
});

export const logout = createAsyncThunk('authenticate/logout',
    async function (_) {
    try {
        await authenticationApi.post("authentication/logout", {},
            {
                headers: { 'Authorization': 'Bearer ' + getAccessToken() }
            });
        localStorage.removeItem("user");
    } catch (err) {
        localStorage.removeItem("user");
    }
});

export const isAuthenticated = createAsyncThunk('authenticate/isAuthenticated',
    async function () {
        try {
            const response = await authenticationApi.post("/Authentication/isAuthenticated");
            if (response.data.token)
                localStorage.setItem("user", JSON.stringify(response.data));

            return response.data;
        }
        catch {
            // 401 is expected when not logged in — don't show an error
            return null;
        }
    });

const processAxiosError = (error: AxiosError, dispatch: any) => {

    const errorMessage = error.message;


     //if (history.navigate != null)
     //    switch (error.response?.status) {
     //        case 404:
     //        case 401:
     //            history.navigate('/login');
     //            break;
     //        case 400:
     //            dispatch(dangerAlert({ message: errorMessage, showAfterRedirect: false }));
     //            break;
     //        default:
     //            history.navigate('/offline');
     //            break;
     //    }
    return dispatch(dangerAlert({ message: errorMessage, showAfterRedirect: true }));
}